import { render, staticRenderFns } from "./chainsDetail.vue?vue&type=template&id=f3f9bb2c&scoped=true&"
import script from "./chainsDetail.js?vue&type=script&lang=js&"
export * from "./chainsDetail.js?vue&type=script&lang=js&"
import style0 from "./chainsDetail.vue?vue&type=style&index=0&id=f3f9bb2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f9bb2c",
  null
  
)

export default component.exports